
window.theme = window.theme || {}

const selectors = {
  heroHotspotSection: '.hero-hotspot',
  heroProductPoints: '[js-hs-product-link]',

}

function debounce(func){
  let timer
  return function(event){
    if (timer) clearTimeout(timer)
    timer = setTimeout(func,100,event)
  }
}

const HeroHotSpot = (() => {

  const initialCoors = [...document.querySelectorAll(selectors.heroProductPoints)].map((point) => {
    return point.style.cssText
  })

  function checkMobileByWidth() {
    return window.innerWidth < 1024 ? true : false
  }

  function pointClickHandler(_event) {
    _event.preventDefault()
    window.location = _event.target.closest('[js-hs-product-link]').getAttribute('js-hs-product-link')
  }

  function setEventsAndPointStyles() {
    [...document.querySelectorAll(selectors.heroProductPoints)].forEach((point) => {
      point.parentNode.replaceChild(point.cloneNode(1), point)
    });
    [...document.querySelectorAll(selectors.heroProductPoints)].forEach((point) => {
      const [yCoord, xCoord] = point.getAttribute('js-mobile-coors').split('_')
      Object.assign(point.style,{ left:`${xCoord}%`,top:`${yCoord}%` })
    })

  }

  function setDesktopPoints() {
    [...document.querySelectorAll(selectors.heroProductPoints)].forEach((point, index) => {
      point.style.cssText = initialCoors[index]
    })
  }

  function mobileEventListeners() {
    [...document.querySelectorAll(selectors.heroProductPoints)].forEach((point) => {
      point.addEventListener('click', pointClickHandler)
    })

  }

  function init() {
    if ((document.querySelector(selectors.heroHotspotSection) == null) || (document.querySelector(selectors.heroHotspotSection) == undefined)) {
      return
    }

    if (checkMobileByWidth()) {
      setEventsAndPointStyles()
      mobileEventListeners()
    }
    window.addEventListener('resize', debounce(() => {
      if (checkMobileByWidth()) {
        setEventsAndPointStyles()
        mobileEventListeners()
      } else {
        setDesktopPoints()
      }
    }))

  }

  return {
    init,
  }
})()

export default HeroHotSpot
